import classNames from "classnames"

import { useAccountSwitcher } from "./useAccountSwitcher"

import styles from "./index.module.scss"

export const AccountSwitcher = () => {
  const {
    contractors,
    handleAccountClick,
    isDropdownOpen,
    isMasterAccountSelected,
    selectedAccountLabel,
    selectedContractorId,
    setDropdownOpen,
    showsAccountSwitcher,
    wrapperRef,
  } = useAccountSwitcher()

  if (!showsAccountSwitcher) return null

  return (
    <div ref={wrapperRef} className={classNames(styles.accountSwitcher)}>
      <button
        className={classNames(styles.trigger, { [styles.triggerActive]: isDropdownOpen })}
        type="button"
        onClick={() => setDropdownOpen(open => !open)}
        aria-expanded={isDropdownOpen}
        aria-haspopup="menu"
        aria-label="Switch account"
      >
        <span>{selectedAccountLabel}</span>
        <span className={classNames(styles.arrow, { [styles.arrowOpen]: isDropdownOpen })} aria-hidden="true" />
      </button>
      <div className={classNames(styles.dropdown, { [styles.dropdownOpen]: isDropdownOpen })} role="menu">
        <div className={styles.dropdownCard}>
          <button
            className={classNames(styles.dropdownItem, {
              [styles.dropdownItemSelected]: isMasterAccountSelected,
              [styles.dropdownItemSelectable]: !isMasterAccountSelected,
            })}
            type="button"
            role="menuitemradio"
            aria-checked={isMasterAccountSelected}
            onClick={() => {
              if (!isMasterAccountSelected) {
                handleAccountClick(null)
              }
            }}
          >
            <span>Master Account</span>
            {isMasterAccountSelected && <span className={styles.checkmark} aria-hidden="true" />}
          </button>
          {contractors.length > 0 ? (
            <>
              {contractors.map(contractor => {
                const isSelected = contractor.id === selectedContractorId
                const handleClick = () => handleAccountClick(contractor.id)

                return (
                  <button
                    key={contractor.id}
                    className={classNames(styles.dropdownItem, {
                      [styles.dropdownItemSelected]: isSelected,
                      [styles.dropdownItemSelectable]: !isSelected,
                    })}
                    type="button"
                    role="menuitemradio"
                    aria-checked={isSelected}
                    onClick={handleClick}
                  >
                    <span>{contractor.name}</span>
                    {isSelected && <span className={styles.checkmark} aria-hidden="true" />}
                  </button>
                )
              })}
            </>
          ) : (
            <div className={styles.emptyState} role="menuitem">
              No contractors found.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
